class ComponentProductCard extends HTMLElement {
  constructor() {
    super()
    this.quickViewBtn = this.querySelector('.quick-view-trigger')
    this.swatches = this.querySelector('.inline-swatch-group')
    if(this.quickViewBtn)
      this.quickViewBtn.addEventListener('click', this.openQuickView.bind(this))
    if(this.swatches)
      this.swatches.querySelectorAll('input').forEach((input)=>{
        input.addEventListener('change', this.onSwatchChange.bind(this))
      })
  }

  openQuickView(e) {
    e.preventDefault()
    $s.showLoadingOverlay();
    var qvUrl = this.quickViewBtn.dataset.url;
    qvUrl += (qvUrl.indexOf('?')>0 ? '&' : '?') + 'sections=product_main';
    $s.getJson({
      url: qvUrl,
      success: (data)=>{
        $s.openModal(data['product_main'], 'product-quick-view');
        $s.globalEval(data["product_main"]);
      },
      always: (data)=>{
        $s.hideLoadingOverlay();
      }
    })
  }

  onSwatchChange() {
    var checkedOption = this.querySelector('.inline-swatch-group input:checked')
    var variantImg = checkedOption.dataset.variantImg
    var variantUrl = checkedOption.dataset.variantUrl
    var priceFinal = checkedOption.dataset.priceFinal
    var priceCompare = checkedOption.dataset.priceCompare

    this.querySelector('.product-card-url').setAttribute('href', variantUrl)
    if (this.quickViewBtn)
      this.quickViewBtn.setAttribute('data-url', variantUrl)
    this.querySelector('.final').innerHTML = priceFinal
    if(this.querySelector('.from')) {
      this.querySelector('.from').style.display = "none"
    }
    if(priceCompare) {
      this.querySelector('.compare').innerHTML = priceCompare
      this.querySelector('.compare').style.display = "block"
    } else {
      this.querySelector('.compare').style.display = "none"
    }
    if(variantImg) {
      this.querySelector('.img.main').setAttribute('srcset', variantImg)
    }
  }
}
customElements.define('product-card', ComponentProductCard);
